import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import { ThemeProvider } from '@/context/ThemeContext';
import { PlayerProvider } from '@/context/PlayerContext';
import { OfflineProvider } from '@/context/OfflineContext';
import { SettingsProvider } from '@/context/SettingsContext';
import App from './App';
import './index.css';

// PWA registration
import { registerSW } from 'virtual:pwa-register';

const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm('Nieuwe versie beschikbaar. Herladen?')) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log('App klaar voor offline gebruik');
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <SettingsProvider>
        <PlayerProvider>
          <OfflineProvider>
            <QueryClientProvider client={queryClient}>
              <BrowserRouter>
                <AuthProvider>
                  <App />
                </AuthProvider>
              </BrowserRouter>
            </QueryClientProvider>
          </OfflineProvider>
        </PlayerProvider>
      </SettingsProvider>
    </ThemeProvider>
  </React.StrictMode>
);
